import { createContext, useContext } from 'react';

/**
 * Opens the global "Report an Error" dialog owned by AppRoutes. Null outside
 * a signed-in session (and in isolated component tests), in which case no
 * diagnostics entry is rendered.
 *
 * V05 placement policy: page chrome that can host the entry (the shared
 * Sidebar, the onboarding footer) renders it and marks itself
 * `data-diagnostics-docked`; the floating ErrorReportingFAB then hides, so it
 * never sits over page commands. The FAB remains the fallback on signed-in
 * surfaces without such chrome, and is always hidden while a dialog is open.
 */
export const ErrorReportingContext = createContext<(() => void) | null>(null);

export const useErrorReporting = () => useContext(ErrorReportingContext);
